module.exports = __webpack_public_path__ + "img/53.c572c66f.png";